import FieldBase from './FieldBase'
import { parsePhoneNumberWithError } from 'libphonenumber-js'

const getPhoneInputValue = (value = '') => {
  try {
    const phoneData = parsePhoneNumberWithError(value || '')
    return {
      phoneNumber: phoneData.nationalNumber || '',
      countryCode: phoneData.country || ''
    }
  } catch {
    return {
      phoneNumber: value || '',
      countryCode: ''
    }
  }
}
export default class extends FieldBase {
  constructor({
    disabled,
    readonly,
    type = 'tel',
    autosize = undefined,
    ...args
  }) {
    super(args)
    const child = this.getComponentWithVModel('vue-phone-number-input')
    const { form, fieldName, fieldValue } = this.formData
    const { phoneNumber, countryCode } = getPhoneInputValue(fieldValue)

    child.attrs.value = phoneNumber
    child.attrs['country-code'] = countryCode
    child.attrs.type = type
    child.attrs.disabled = disabled
    child.attrs.readonly = readonly
    child.attrs.autosize = autosize

    child.props = {'default-country-code': countryCode}

    child.listeners = {
      update: phoneData => {
        const newValue = phoneData.e164 || phoneData.phoneNumber
        if (newValue === fieldValue) return
        this.setValues(form, fieldName, newValue)
      }
    }

    this.children = [child]
  }
}
